import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// sidebarOpen (the desktop collapse/expand state) is persisted — every page
// mounts its own <Sidebar />, so plain component state reset to its default
// on every navigation. mobileSidebarOpen is intentionally NOT persisted:
// it's just whether the mobile overlay is open right now, which should
// always start closed on a fresh page load.
const useUiStore = create(
  persist(
    (set) => ({
      mobileSidebarOpen: false,
      openMobileSidebar: () => set({ mobileSidebarOpen: true }),
      closeMobileSidebar: () => set({ mobileSidebarOpen: false }),
      toggleMobileSidebar: () => set((state) => ({ mobileSidebarOpen: !state.mobileSidebarOpen })),

      sidebarOpen: true,
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
    }),
    {
      name: 'ui-storage',
      partialize: (state) => ({ sidebarOpen: state.sidebarOpen }),
    }
  )
);

export default useUiStore;
